import ContactItem from './ContactItem';
import { Head_3 } from '../Typography';
import { faPhone, faHome, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons';

const infoContact = [
  {
    icon: faPhone,
    title: 'Phone',
    content: '+970 597 853623'
  },
  {
    icon: faEnvelope,
    title: 'Email',
    content: 'elhamelshami.dev@gmail.com'
  },
  {
    icon: faHome,
    title: 'Address',
    content: 'Al Jalaa, Gaza, Palestine'
  },
  {
    icon: faLinkedinIn,
    title: 'LinkedIn',
    content: 'Elham Elshami'
  }
];
const ContactOptions = () => {
  return (
    <div className="contact-options">
      <Head_3>Feel Free to Contact Me!</Head_3>
      {infoContact.map((item) => {
        return <ContactItem key={item.title} {...item} />;
      })}
    </div>
  );
};

export default ContactOptions;
